module.exports = __webpack_public_path__ + "static/media/icon_01.b7e6e729.svg";